module.exports = __webpack_public_path__ + "static/media/estimate.995efaf8.svg";